module.exports = __webpack_public_path__ + "static/Print pattern XS-03_logobase_3000-01-a0910f60359336cf9354a8fb322cb970.png";